import axios from 'src/app-axios';
import Constants from 'src/constants';
import moment from 'moment';

export const widgets = {
    namespaced: true,
    state: {
        alertHistories: [],
        alertResponses: [],
        responseStatus: {},
        responseStatusUpdatedAt: '',
        suspiciousCheckIns: [],
    },
    getters: {
        getAlertHistories (state) {
            return state.alertHistories;
        },
        getAlertResponses (state) {
            return state.alertResponses;
        },
        getResponseStatus (state) {
            return state.responseStatus;
        },
        getResponseLastUpdatedAt (state) {
            return state.responseStatusUpdatedAt;
        },
        getSuspiciousCheckIns (state) {
            return state.suspiciousCheckIns;
        },
    },
    mutations: {
        setAlertHistories (state, histories) {
            state.alertHistories = histories;
        },
        setAlertResponses (state, responses) {
            state.alertResponses = responses;
        },
        setResponseStatus (state, { serviceProviderExtId, event }) {
            if (serviceProviderExtId in state.responseStatus) {
                state.responseStatus[serviceProviderExtId].unshift(event.response);
                return;
            }
            state.responseStatus[serviceProviderExtId] = [event.response];
        },
        setResponseUpdatedAt (state, dateTime) {
            state.responseStatusUpdatedAt = dateTime;
        },
        setSuspiciousCheckIns (state, data) {
            state.suspiciousCheckIns = data;
        },
    },
    actions: {
        async fetchAlertHistories ({ dispatch, commit }) {
            const url = 'api/alert-messages';
            try {
                const histories = await axios.get(url);
                commit('setAlertHistories', histories.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the alert histories list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async sendEmergencyMessage ({ dispatch }, payload) {
            const url = 'api/alert';
            try {
                await axios.post(url, payload.emergencyMessage);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in sending the message.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchAlertResponses ({ dispatch, commit }, payload) {
            const url = `api/alert-messages/${payload.alertId}/responses`;
            try {
                const responses = await axios.get(url);
                commit('setAlertResponses', responses.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the alert responses list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        addResponseStatus (context, event) {
            context.commit('setResponseStatus', {
                serviceProviderExtId: event.service_provider_id,
                event: event.service_provider_response,
            });
            context.commit('setResponseUpdatedAt', moment().toISOString());
        },
        async fetchSuspiciousCheckIns ({ dispatch, commit }) {
            const url = 'api/suspicious-activity';
            try {
                const responses = await axios.get(url);
                commit('setSuspiciousCheckIns', responses.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the suspicious check-ins list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchFilteredSuspiciousRecords ({ dispatch, commit }, payload) {
            const url = 'api/suspicious-activity';
            try {
                const records = await axios.get(url, payload);
                commit('setSuspiciousCheckIns', records.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the filtered check-in records list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
    },
};
